export default __webpack_public_path__ + "static/char-v-07-9e7a149eaeb564d09bd99f9da2748de1.png";